import React from 'react';
import Layout from './Layout';

const TrainingResources = () => {
  return (
    <Layout>
      <iframe
        className="trainingresources"
        src="https://coda.io/embed/djKoQQcsR1/_suQe9KuA?viewMode=embedpreview"
        allow="fullscreen"
        style={{
          width: '100%',
          height: '85vh',
          border: 'none',
        }}
      />
    </Layout>
  );
};

export default TrainingResources;
